import InlineToolbar from './InlineToolbar';
export default InlineToolbar;


// WEBPACK FOOTER //
// ./src/components/InlineToolbar/index.js